// Convierte cualquier error (axios, red, servidor) en un mensaje claro en
// español para el equipo político. Nunca muestra jerga técnica tipo
// "Request failed with status code 500" o "Network Error".
//
// Prioridad: si el backend mandó su propio mensaje (response.data.error),
// se usa ese (suele estar ya redactado para el usuario). Si no, se traduce
// el tipo de falla a lenguaje llano.

const STATUS_MESSAGES = {
  400: 'Faltan datos o algo no es válido. Revisá lo cargado e intentá de nuevo.',
  401: 'Tu sesión expiró. Volvé a iniciar sesión.',
  403: 'No tenés permiso para ver o hacer esto.',
  404: 'No encontramos esta información.',
  408: 'La consulta tardó demasiado. Probá de nuevo.',
  409: 'Hubo un conflicto con el estado actual. Refrescá e intentá de nuevo.',
  413: 'El archivo o el contenido es demasiado grande.',
  429: 'Demasiadas consultas seguidas. Esperá unos segundos y reintentá.',
  500: 'El servidor tuvo un problema. Probá de nuevo en un momento.',
  502: 'El servidor no está respondiendo bien. Probá de nuevo en un momento.',
  503: 'El servicio está momentáneamente fuera de línea. Probá de nuevo en un rato.',
  504: 'La consulta tardó demasiado y se cortó. Probá de nuevo.',
};

export function friendlyError(err, fallback = 'No se pudo completar la acción. Probá de nuevo.') {
  if (!err) return fallback;

  // 1) Mensaje propio del backend (ya redactado para el usuario)
  const backend = err?.response?.data?.error ?? err?.response?.data?.detail;
  if (backend) {
    if (typeof backend === 'string') return backend;
    if (typeof backend === 'object') return backend.message || backend.detail || fallback;
  }

  // 2) Error HTTP con status conocido
  const status = err?.response?.status;
  if (status && STATUS_MESSAGES[status]) return STATUS_MESSAGES[status];
  if (status && status >= 500) return STATUS_MESSAGES[500];

  // 3) Sin respuesta del servidor = problema de red/conexión
  const raw = String(err?.message || '');
  if (err?.request && !err?.response) {
    return 'No hay conexión con el servidor. Revisá tu internet e intentá de nuevo.';
  }
  if (/network|failed to fetch|err_network|econnrefused/i.test(raw)) {
    return 'No hay conexión con el servidor. Revisá tu internet e intentá de nuevo.';
  }
  if (/timeout|timed out/i.test(raw)) {
    return 'La consulta tardó demasiado. Probá de nuevo.';
  }

  // 4) Último recurso: si el mensaje crudo parece técnico, usamos el fallback
  if (!raw || /request failed|status code|xhr|axios|undefined|\bnull\b/i.test(raw)) {
    return fallback;
  }
  return raw;
}

export default friendlyError;
